<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <div class="form-group mb-15 mb-sm-20 mb-md-25">
          <label class="d-block text-black fw-semibold mb-10"> Mot clé </label>
          <Field v-model="motCle" name="mot" type="text" aria-disabled="true"
            class="form-control shadow-none fs-md-15 text-black" placeholder="Recherche par mot clé" />
          <ErrorMessage name="mot" class="text-danger" />
        </div>
      </div>
      <div class="d-sm-flex align-items-center">
        <button
          v-if="checkParentPermission(['AddZone'])"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          type="button" @click="ajouterZone" data-bs-toggle="modal" data-bs-target="#ZoneModal">
          <i class="fa fa-plus-circle"></i>
          Ajouter une zone
        </button>
        <button
          @click="telecharger"
          :disabled="isLoading"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-info fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          type="button">
          <i class="flaticon-download position-relative ms-5 fs-12"></i>
          <span v-if="!isLoading">Exporter</span>
          <span v-else>
            <span class="spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
            Export en cours...
          </span>
        </button>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <hr />
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Code</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Libellé</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Marché</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in zones" :key="index">
              <td class="shadow-none lh-1 fw-medium">{{ item.code_zone }}</td>
              <td class="shadow-none lh-1 fw-medium">{{ item.libelle_zone }}</td>
              <td class="shadow-none lh-1 fw-medium">{{ item.marche?.nomMarche }}</td>
              <td class="shadow-none lh-1 fw-medium text-end pe-0">
                <div class="dropdown">
                  <span class="badge text-white bg-secondary fs-15 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                    Actions
                    <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li v-if="checkPermission('EditZone')">
                      <a href="#" class="dropdown-item d-flex align-items-center" data-bs-toggle="modal"
                        data-bs-target="#ZoneModal" @click="modifierZone(item.code_zone)" type="button">
                        <i class="flaticon-view lh-1 me-8 position-relative top-1"></i>
                        Modifier
                      </a>
                    </li>
                    <li v-if="checkPermission('DeleteZone')">
                      <a href="#" @click="supprimerZone(item.code_zone)" class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        Supprimer
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
            <tr v-if="zones.length === 0">
              <td colspan="4" class="text-center">Aucune zone trouvée</td>
            </tr>
          </tbody>
        </table>
      </div>
      <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
        @paginate="handlePaginate" />
    </div>
  </div>
  <ZoneModal :item="selectedItem ?? undefined" @close="recharger" @open="show_Modal" />
</template>
<script lang="ts">
import { ref, defineComponent, onMounted, watch } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import ZoneModal from "./ZoneModal.vue";
import PaginationComponent from "@/components/Utilities/Pagination.vue";
import { error, success, downloadExcel, getUrlApiForFiles } from "@/utils/utils";
import JwtService from "@/services/JwtService";
import axios from "axios";
import Swal from "sweetalert2";

export default defineComponent({
  name: "ListeZone",
  components: { Field, ErrorMessage, ZoneModal, PaginationComponent },
  setup: () => {
    const zones = ref<Array<any>>([]);
    const motCle = ref("");
    const selectedItem = ref<number | string | null>(null);
    const isLoading = ref(false);
    const valideEtape3 = ref(true);
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const show_Modal = (el) => { selectedItem.value = null; };
    const ajouterZone = () => { selectedItem.value = null; };
    const modifierZone = (code) => { selectedItem.value = code; };
    const recharger = () => { actionRecherche(page.value, limit.value); };

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        limit.value = limit_;
        actionRecherche(page_, limit_);
      } catch (error) {
        //
      }
    };

    const actionRecherche = async (pageNum = 1, limi = 10) => {
      try {
        const element = {
          motCle: motCle.value,
          mot: motCle.value,
          page: pageNum,
          limit: limi,
          totalPages: totalPages.value,
          totalElements: totalElements.value,
        };
        const response = await axios.post("zones/liste", element);
        if (response.data && response.data.data) {
          zones.value = response.data.data.data;
          totalPages.value = response.data.data.totalPages;
          limit.value = response.data.data.limit;
          totalElements.value = response.data.data.totalElements;
          page.value = pageNum;
        }
      } catch (err) {
        error(axios.isAxiosError(err) && err.response ? err.response.data.message || err.message : err instanceof Error ? err.message : String(err));
      }
    };

    const supprimerZone = async (code: string) => {
      try {
        Swal.fire({
          text: `Vous êtes sur le point de supprimer cette zone. Etes-vous sûr ?`,
          icon: "warning",
          buttonsStyling: true,
          showCancelButton: true,
          confirmButtonText: "Supprimer",
          cancelButtonText: `Annuler`,
          heightAuto: false,
          customClass: { confirmButton: "btn btn-danger" },
        }).then(async (result) => {
          if (result.isConfirmed) {
            const response = await axios.delete(`zone/${code}`);
            if (response.data && response.data.code === 200) {
              success(response.data.message || "Zone supprimée avec succès");
              await actionRecherche(page.value, limit.value);
            }
          }
        })
        .catch(async ({ response }) => {
          error(response?.data?.message || "Erreur lors de la suppression");
        });
      } catch (err) {
        error(err instanceof Error ? err.message : String(err));
      }
    };

    const telecharger = async () => {
      valideEtape3.value = false;
      isLoading.value = true;
      try {
        const element = {
          motCle: motCle.value,
        };
        // TODO: Créer endpoint POST zone/export au backend
        const response = await axios.post("zone/export", element);
        if (response.data && response.data.data) {
          const downloadUrl = getUrlApiForFiles("Excel", response.data.data + ".xlsx");
          await downloadExcel(downloadUrl);
          success("Export réussi");
        }
        valideEtape3.value = true;
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          error(err instanceof Error ? err.message : String(err));
        }
        valideEtape3.value = true;
      } finally {
        isLoading.value = false;
      }
    };

    watch(motCle, () => { 
      page.value = 1;
      actionRecherche(1, limit.value); 
    });

    const privileges = ref<Array<string>>(JwtService.getPrivilege());
    const checkPermission = (name) => privileges.value.includes(name);
    const checkParentPermission = (permissions) => {
      for (const permission of permissions) {
        if (checkPermission(permission)) return true;
      }
      return false;
    };

    onMounted(async () => { await actionRecherche(1, 10); });

    return { zones, motCle, selectedItem, show_Modal, ajouterZone, modifierZone, recharger, supprimerZone, checkPermission, checkParentPermission, telecharger, isLoading, valideEtape3, page, totalPages, limit, totalElements, handlePaginate };
  },
});
</script>

